exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#aa-video-ad-unit .toast {\n  opacity: 1.0;\n  background: rgba(0,0,0,200);\n  color: white;\n  padding: 12px;\n  border-radius: 8px;\n  position: absolute;\n  bottom: 48px;\n  left: 0;\n  right: 0;\n  margin: auto;\n  animation: fade-out 0.125s 1;\n  animation-delay: 2s;\n  animation-fill-mode: forwards;\n  -webkit-animation: fade-out 0.125s 1;\n  -webkit-animation-delay: 2s;\n  -webkit-animation-fill-mode: forwards;\n\n  text-align: center;\n  font-size: 11pt;\n  width: 180px;\n  background-color: rgba(0, 167, 95, 0.75);\n  z-index: 4;\n}\n\n@media only screen and (max-width: 400px) {\n  #aa-video-ad-unit .toast {\n    bottom: 32px;\n    padding: 8px;\n    width: 140px;\n    font-size: 9pt;\n  }\n}\n\n@keyframes fade-out {\n  from { opacity : 1 }\n  to   { opacity : 0 }\n}\n\n@-webkit-keyframes fade-out {\n  from { opacity : 1 }\n  to   { opacity : 0 }\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/Display/Components/Toast/Toast.css
// module id = 187
// module chunks = 6